import { useEffect, useRef } from "react";

export default function useSwipeGesture({ onSwipeLeft, onSwipeRight, isMenuVisible }) {
  const touchStartX = useRef(null);
  const touchEndX = useRef(null);
  const touchStartY = useRef(null);
  const touchEndY = useRef(null);
  const SWIPE_THRESHOLD_PERCENT = 0.3;
  const Y_SWIPE_THRESHOLD_PERCENT = 0.12;

  useEffect(() => {
    const handleTouchStart = (e) => (touchStartX.current = e.touches[0].clientX, touchStartY.current = e.touches[0].clientY);
    const handleTouchMove = (e) => (touchEndX.current = e.touches[0].clientX, touchEndY.current = e.touches[0].clientY);
    const handleTouchEnd = () => {
      if (touchStartX.current === null || touchEndX.current === null) return;

      const swipeDistance = touchStartX.current - touchEndX.current;
      const threshold = window.innerWidth * SWIPE_THRESHOLD_PERCENT;
     
      const ySwipeDistance = Math.abs(touchStartY.current - touchEndY.current);
      const yThreshold = window.innerHeight * Y_SWIPE_THRESHOLD_PERCENT;

      if(ySwipeDistance > yThreshold ) {
        touchStartY.current = null;
        touchEndY.current = null;
        return;
      }

      if (swipeDistance > threshold) onSwipeLeft?.();
      if (touchEndX.current - touchStartX.current > threshold && isMenuVisible) onSwipeRight?.();

      touchStartX.current = null;
      touchEndX.current = null;
    };

    window.addEventListener("touchstart", handleTouchStart);
    window.addEventListener("touchmove", handleTouchMove);
    window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("touchstart", handleTouchStart);
      window.removeEventListener("touchmove", handleTouchMove);
      window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [onSwipeLeft, onSwipeRight, isMenuVisible]);
}
